import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'
import { theme } from '../../themes/theme'
import { Page, CenteredFlexColumn } from '../styles/Containers'

const Spinner = styled(CircularProgress)`
  color: ${theme.colors.primary};
`

const Loading = ({ children }) => (
  <Page>
    <CenteredFlexColumn>
      <Spinner size={70} />
      {children}
    </CenteredFlexColumn>
  </Page>
)

Loading.propTypes = {
  children: PropTypes.node
}

export default Loading
